module.exports = __webpack_public_path__ + "packaging.jpg?7caadd463e61d2c0625de9755ead1f76";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/packaging.jpg
// module id = 21
// module chunks = 0